export { default as ShowMoreText } from './show-more-text'
